import { LogOut, User } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("siteId");
    navigate("/login");
  };

  return (
    <header className="navbar">
      <div className="navbar-left">
        <h2 className="navbar-logo">Painel Transparência</h2>
      </div>

      <div className="navbar-right">
        <div className="navbar-user">
          <div className="avatar">G</div>
          <div className="user-info">
            <span className="user-name">Gestor</span>
            <span className="user-role">Administrador</span>
          </div>
        </div>

        <div className="divider"></div>

        <button className="btn-logout" onClick={handleLogout} title="Sair do sistema">
          <LogOut size={16} strokeWidth={2.5} />
          <span>Sair</span>
        </button>
      </div>
    </header>
  );
}